import {
  AuthDispatch,
  AuthDispatchContext,
} from "../contexts/AuthDispatchContext";
import { AuthState, AuthStateContext } from "../contexts/AuthStateContext";

export function MainModule(params: {
  main: React.ReactNode;
  authState: AuthState;
  authDispatch: AuthDispatch;
}) {
  return (
    <AuthDispatchContext.Provider value={params.authDispatch}>
      <AuthStateContext.Provider value={params.authState}>
        {params.main}
      </AuthStateContext.Provider>
    </AuthDispatchContext.Provider>
  );
}
